import { gql } from '@apollo/client'

export const SEARCH = gql`
  query ($name: String!, $label_id: String, $is_global: Boolean = false) {
    search(name: $name, label_id: $label_id, is_global: $is_global) {
      campaigns {
        active
        name
        id
        campaign_id
        artist {
          spotify_id
          name
          facebook_id
        }
      }
      products {
        active
        name
        id
        parent_id
        campaign_id
        campaign {
          name
        }
      }
    }
  }
`
